/**
 * In-memory pharmacy_licenses cache used by Gate 1 lookups.
 * Hydrated from API / Redux — no local seed roster.
 */
import { PharmacyLicense } from "./types";

let pharmacyLicensesTable: PharmacyLicense[] = [];

/** Replace the in-memory pharmacy_licenses table (e.g. after API fetch). */
export function hydratePharmacyLicenseTable(rows: PharmacyLicense[]): void {
  pharmacyLicensesTable = Array.isArray(rows) ? [...rows] : [];
}

/** Current pharmacy_licenses rows (copy). */
export function getPharmacyLicenseTable(): PharmacyLicense[] {
  return [...pharmacyLicensesTable];
}

/** Clear the in-memory table (tests / logout). */
export function clearPharmacyLicenseTable(): void {
  pharmacyLicensesTable = [];
}

/**
 * Look up one pharmacy_licenses row by pharmacy_id + state.
 * Optional `rows` override is used when the caller already has table data
 * (e.g. from Redux) without relying on the module cache.
 */
export function queryPharmacyLicense(
  pharmacyId: number,
  state: string,
  rows?: PharmacyLicense[]
): PharmacyLicense | null {
  const code = (state || "").trim().toUpperCase();
  if (!code) return null;

  const source = rows && rows.length > 0 ? rows : pharmacyLicensesTable;

  return (
    source.find(
      (row) => row.pharmacy_id === pharmacyId && row.state === code
    ) ?? null
  );
}
